@link fn getScissorMin() -> vec4<f32>;
@link fn getScissorMax() -> vec4<f32>;
@link fn getScissorBias() -> f32;

@export fn getScissorBox(value: vec4<f32>) -> vec4<f32> {

  let smin = getScissorMin();
  let smax = getScissorMax();
  let bias = getScissorBias();

  let vmin = value - smin;
  let vmax = smax - value;

  return min(vmin, vmax) + bias;
};
